import * as React from 'react'
import { Tab, Transition } from 'semantic-ui-react'
import { homeService } from '../../../../../services'
import { toast } from 'react-toastify'

type InfoTabState = {
  paneInfo: IAboutPaneInfo[],
  visible: boolean,
  marquee: string,
}

export class InfoTab extends React.Component {
  state: InfoTabState = {
    paneInfo: [],
    visible: true,
    marquee: ''
  }

  componentDidMount() {
    homeService.getAboutInfo()
      .then(value => this.setState({
        paneInfo: value
      }))
      .catch(error => toast.error(error.message))
  }

  toggleVisibility = () => this.setState({visible: !this.state.visible})

  convert(paneInfo: IAboutPaneInfo[], visible: boolean): IPane[] {
    return paneInfo.map(value => {
      return {
        menuItem: value.name,
        render: () => (
          <Tab.Pane attached={false}>
            <Transition visible={visible} animation="scale" duration={500}>
              <div dangerouslySetInnerHTML={{__html: value.content}}/>
            </Transition>
          </Tab.Pane>
        )
      }
    })
  }

  render() {
    const {paneInfo, visible} = this.state

    return (
      <div>
        <Tab menu={{secondary: true, pointing: true}} panes={this.convert(paneInfo, visible)}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/RollItemStore/components/InfoTab.tsx